import React, {useEffect, useState} from "react";
import axios from "axios";
import { useHistory, useParams, Link } from "react-router-dom";
import Header from "../../common/Header";
import SideBar from "../../common/SideBar";
import AuditTrail from "../projectScripts/AuditTrail";
import Swal from "sweetalert2";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import PCTemplateDetails from "./PCTemplateDetails";
import {
  GetPCTemplate
} from "../../../services/ProjectCenterServices";
function PCTemplateOpenWrapper() {
  const history = useHistory();
  const { type, id } = useParams();
  const [loading, setLoading] = useState(Boolean(id));
  const [templateName, setTemplateName] = useState(null);
  const [reload, setReload] = useState(false);
  const [templateDetails, setTemplateDetails] = useState(null);
  usePermissionGuardRedirect(
    type === "open" || type == 'audittrail' ? ["projectcentertemplatesview"] : ["projectcentertemplatesadd"]
  );
    useEffect(() => {
    if (!id) return;

    const source = axios.CancelToken.source();

      const getTemplate = async () => {
        setLoading(true);
        try {
          const res = await GetPCTemplate(id, source.token);
          if (res.status === 200) {
            setTemplateName(res?.data?.data?.name);
            setTemplateDetails(res?.data?.data);
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.error(error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Unable to load template",
            });
          }
        } finally {
          setLoading(false);
        }
      };
      if (Boolean(id) && id > 0) {
        getTemplate();
      }

      return () => {
        source.cancel("Component unmounted");
      };
    }, [id]);

  return (
    <>
      <Header />
      <div className="content-wrapper d-flex flex-wrap">
        <SideBar />
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center ">
                    <div className="name-w-head d-flex align-items-center">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        Project {templateName ? <> Template: <span>{templateName}</span></> : <span>Template</span>}
                      </h4>
                    </div>

                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <button
                            onClick={() => history.goBack()}
                            title="Back"
                            className="btn btn-white-bordered"
                          >
                            <i className="fal fa-angle-left"></i>Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tabs-wrap">
                  {(type === "open" || type === "audittrail") && (
                    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(`/project-center/templates/open/${id}`)
                        }
                      >
                        <Link
                          className={`nav-link ${type === "open" && "active"}`}
                          id="pills-tab1"
                          data-toggle="pill"
                          to={`/project-center/templates/open/${id}`}
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                          title="Template Details"
                        >
                          <i className="fa fa-info-circle"></i>
                          Details
                        </Link>
                      </li>
                      {/* <li
                        className="nav-item"
                        onClick={() =>
                          history.push(`/project-center/templates/audittrail/${id}`)
                        }
                      >
                        <Link
                          className={`nav-link ${type === "audittrail" && "active"}`}
                          id="pills-tab2"
                          data-toggle="pill"
                          to={`/project-center/templates/audittrail/${id}`}
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="true"
                          title="Audit trail"
                        >
                          <i className="fal fa-history"></i>Audit trail
                        </Link>
                      </li> */}
                    </ul>
                  )}

                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab11"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      {type === "open" && <PCTemplateDetails 
                      id={id}
                      templateDetails={templateDetails}
                      loading={loading}
                      setLoading={setLoading}
                      setReload={setReload} 
                      reload={reload}
                      />}
                      {type  === "audittrail" && <AuditTrail id={id} entityType="project_template" />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PCTemplateOpenWrapper;